// @flow

import { Component } from '~/sources/scripts/jsti/core';

type FlowboxInitializationData = {
  container: string,
  key: string,
  locale: string,
  productId?: string,
  tags: Array<string>
};

export default class Flowbox extends Component {
  /**
   * Instantiate the component
   */
  bind(el: HTMLElement): void {
    super.bind(el);

    if (!window.flowbox) {
      throw new Error('Flowbox is not available');
    }

    window.flowbox('init', this.initializationData);
  }

  /**
   * Getter for the initialization data, needed to set up flowbox
   */
  get initializationData(): FlowboxInitializationData {
    let tags;
    try {
      tags = JSON.parse(this.el.dataset.tags);
    } catch {
      tags = [];
    }
    const initializationData = {
      container: `#${this.el.id}`,
      key: this.el.dataset.key,
      tags: tags,
      locale: window.store.environment.locale
    };

    if (this.el.dataset.productIdentifier) {
      initializationData.productId = this.el.dataset.productIdentifier;
    }

    return initializationData;
  }
}
